(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccineDeleteController',VaccineDeleteController);

    VaccineDeleteController.$inject = ['$uibModalInstance', 'entity', 'Vaccine'];

    function VaccineDeleteController($uibModalInstance, entity, Vaccine) {
        var vm = this;

        vm.vaccine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Vaccine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
